import React, { useEffect, useState } from "react";

export default function CookiesConsent(){
    const cookieOverlay = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: 'calc(100%)',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: '9999',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const cookieDialog = {
        padding: '20px',
        textAlign: 'left',
        borderRadius: '5px',
        maxWidth: '80%',
        zIndex: '10000',
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
    }
    const cookieDialogTitle = {fontWeight: 'bold'}
    const cookieDialogButtonContainer = {fontWeight: 'bold'}
    const [cookiesAccepted, setCookiesAccepted] = useState(false);
    useEffect(() => {
        if (localStorage.getItem('cookiesAccepted')) {
            setCookiesAccepted(true);
        }
    }, []);
    const onAcceptCookies = () => {
        setCookiesAccepted(true);
        localStorage.setItem('cookiesAccepted', 'true');
    };
    if (cookiesAccepted) {
        return null;
    }
    return(
        <div style={cookieOverlay}>
            <div style={cookieDialog} className="bg-secondary">
                <div style={cookieDialogTitle}>Utilizamos cookies 🍪</div>
                <p className="mt-2">
                    Utilizamos cookies esenciales para que el sitio funcione, sin estas no podrías hacer uso de Pilates Rizzo.
                </p>
                <p>Dispone de más información en nuestra <a href="/politica-cookies" target="_blank" className="text-primary">Política de cookies</a>.</p>
                <div style={cookieDialogButtonContainer}>
                    <button className="btn btn-primary" onClick={onAcceptCookies}>Aceptar</button>
                </div>
            </div>          
        </div>
    )
}
